let domLoaded = false;
let igReady = false;

function handleExperiments() {
    if (!domLoaded || !igReady) return;

    // V_TBE_HP_01 | HP - Banner Revamp
    const heroBannerRevamp = window.igData?.user.getTestGroup("68a1a669-8b17-48c7-b0aa-6908f45f4f95");
    if (heroBannerRevamp?.name === "Var A - Copy only") {
        document.body.classList.add("c-heroBannerRevamp-varA");
    } else if (heroBannerRevamp?.name === "Var B - Copy And Image") {
        document.body.classList.add("c-heroBannerRevamp-varB");
    }

    // V_TBE_PDP_04 | PDP - Save x% vs $x
    const saveLabel = window.igData?.user.getTestGroup("6d7c9de9-a007-4580-ae87-76bf3bccb378");
    if (saveLabel?.name === "Var A - Percentage") {
        document.body.classList.add("c-saveLabel-varA");
    } else if (saveLabel?.name === "Var B - Dollar") {
        document.body.classList.add("c-saveLabel-varB");
    }

    // V_TBE_HP_06 | Shop Collection Section - HP
    const shopCollectionHP = window.igData?.user.getTestGroup("4d3683ba-865c-4331-80b7-6486b4eecefe");
    if (shopCollectionHP?.name === "Var A - Category Tiles") {
        document.body.classList.add("c-shopCollectionHP-varA");
    } else if (shopCollectionHP?.name === "Var B - Filtered Product Grid") {
        document.body.classList.add("c-shopCollectionHP-varB");
    } 

}

document.addEventListener("DOMContentLoaded", () => {
    domLoaded = true;
    handleExperiments();
});

window.addEventListener("ig:ready", () => {
    igReady = true;
    handleExperiments();
});